import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useCallback } from "react";

const VALIDATE_WASTE_STREAMS = gql(`
  query ValidateWasteStreams(
    $wasteStreamIds: [ID!]!
    $startDate: Date
    $endDate: Date
  ) {
    wasteStreamInputValidator(
      wasteStreamIds: $wasteStreamIds
      startDate: $startDate
      endDate: $endDate
    ) {
      wasteStreamId
      issues {
        ...issue
      }
    }
  }
`);

export function useWasteStreamInputValidation() {
  const [query, { loading }] = useLazyQuery(VALIDATE_WASTE_STREAMS, {
    fetchPolicy: "no-cache",
  });

  const validate = useCallback(
    async (wasteStreamIds: string[], options?: { startDate?: string; endDate?: string }) => {
      if (wasteStreamIds.length === 0) {
        return [];
      }

      const { data, previousData } = await query({
        variables: {
          wasteStreamIds,
          ...(options?.startDate != null && options?.endDate != null
            ? { startDate: options.startDate, endDate: options.endDate }
            : {}),
        },
      });

      return data
        ? data?.wasteStreamInputValidator
        : (previousData?.wasteStreamInputValidator ?? []);
    },
    [query]
  );

  return { validate, loading };
}
